<script>
import { mapGetters, mapActions } from "vuex";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import { date_ranges } from "../../../state/helpers";
import moment from "moment";
import appConfig from "@/app.config";
// import { param } from "express/lib/request";
/**
 * Add-product component
 */
export default {
  page: {
    title: "Charger Report",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { DateRangePicker },
  data() {
    return {
      sortBy: "id",
      perPages: 5,
      sortDesc: true,
      page: 1,
      paginations: {},
      limit: 10,
      search: "",
      moment: moment,
      id: "",
      date_ranges: date_ranges,
      filters: {
        start_date: moment().startOf("day").subtract(29, "days").format("YYYY-MM-DD"),
        end_date: moment().format("YYYY-MM-DD"),
      },
      dateRange: {
        startDate: moment().startOf("day").subtract(29, "days"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      fields: [
        {
          key: "users",
          sortable: true,
          label: "User Name",
        },
        {
          key: "email",
          sortable: true,
          label: "Email",
        },
        {
          key: "mobile_number",
          sortable: true,
          label: "Mobile Number",
        },
        {
          key: "provider_name",
          sortable: true,
          label: "Provider Name",
        },
        {
          key: "bookings_count",
          sortable: true,
          label: "Bookings",
        },
        {
          key: "action",
          sortable: false,
          label: "Action",
        },
      ],
    };
  },
  props: ["userId"],
  validations: {},
  computed: {
    ...mapGetters("report", [
      "getAllUserReport",
      "loading",
      "userReportCount",
      "pagination",
    ]),
  },
  mounted() {
    this.getUserReports(this.page);
  },
  methods: {
    ...mapActions("report", ["getUserReport"]),
    getUserReports(page = 1) {
      var filters = {
        ...this.filters,
        search: this.search,
        sortBy: this.sortBy,
        orderBy: this.sortDesc ? "desc" : "asc",
        page: page && page > 0 ? page : 1,
        perPages: this.perPages,
      };
      this.getUserReport(filters);
    },
    updateValues(date) {
      this.filters = {
        ...this.filters,
        start_date: moment(date.startDate.toISOString()).format("YYYY-MM-DD"),
        end_date: moment(date.endDate.toISOString()).format("YYYY-MM-DD"),
      };
      this.getUserReports();
    },
    dateFormat(classes, date) {
      this.filters = {
        ...this.filters,
        start_date: moment(date.startDate.toISOString()).format("YYYY-MM-DD"),
        end_date: moment(date.endDate.toISOString()).format("YYYY-MM-DD"),
      };
    },
    sortingChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.getUserReports();
    },
  },
  filters: {
    date(val) {
      return val ? val.toLocaleString() : "";
    },
  },
};
</script>
<template>
  <div class="row">
    <div class="col-12">
      <form action="#" @submit.prevent="typeForm">
        <!-- profile Info Start -->
        <div class="card date-picker-space">
          <div class="card-body">
            <div class="col-md-12">
              <div
                class="page-title-box d-flex align-items-center justify-content-between icon-main-page"
              >
                <h4 class="card-title page-title-left">
                  User Reports ({{ userReportCount }})
                </h4>
                <div class="date-range-list">
                  <label>Start Date - End Date</label>
                  <date-range-picker
                    ref="picker"
                    :locale-data="{
                      firstDay: 1,
                      format: 'dd-mm-yyyy',
                    }"
                    :showDropdowns="true"
                    :showWeekNumbers="true"
                    opens="left"
                    v-model="dateRange"
                    class="w-250"
                    :ranges="date_ranges()"
                    @update="updateValues"
                  >
                    <template v-slot:input="picker" style="min-width: 350px">
                      {{
                        moment(picker.startDate.toISOString()).format("DD-MM-YYYY") | date
                      }}
                      -
                      {{
                        moment(picker.endDate.toISOString()).format("DD-MM-YYYY") | date
                      }}
                    </template>
                  </date-range-picker>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <b-table
                  striped
                  hover
                  :items="getAllUserReport"
                  :update:sortBy="sortBy"
                  :update:sortDesc="sortDesc"
                  :no-local-sorting="true"
                  @sort-changed="sortingChanged"
                  :fields="fields"
                  :busy="loading"
                >
                  <template #table-busy>
                    <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>{{ $t(" Loading") }}</strong>
                    </div>
                  </template>
                  <template v-slot:cell(users)="items">
                    {{
                      items.item.users
                        ? items.item.users
                        : items.item.first_name
                        ? items.item.first_name
                        : "-"
                    }}
                  </template>
                  <template v-slot:cell(email)="items">
                    {{ items.item.email ? items.item.email : "-" }}
                  </template>
                  <template v-slot:cell(mobile_number)="items">
                    {{ items.item.mobile_number ? items.item.mobile_number : "-" }}
                  </template>
                  <template v-slot:cell(provider_name)="items">
                    {{
                      items.item.provider_name
                        ? items.item.provider_name.toUpperCase()
                        : "NORMAL"
                    }}
                  </template>
                  <template v-slot:cell(bookings_count)="items">
                    <span
                      v-if="items.item.bookings_count == '0'"
                      class="badge badge-danger"
                    >
                      {{ items.item.bookings_count }}
                    </span>
                    <span v-else class="badge badge-primary">
                      {{ items.item.bookings_count }}
                    </span>
                  </template>
                  <template v-slot:cell(action)="items">
                    <b-button
                      @click="
                        $router.push({
                          name: 'user-analytics',
                          params: { user_id: base64(items.item.id) },
                        })
                      "
                      class="btn btn-sm btn-secondary btn-rounded"
                    >
                      <i class="bx bxs-bar-chart-alt-2"> Analytics</i>
                    </b-button>
                  </template>
                </b-table>
                <tr v-if="loading == false && getAllUserReport == 0">
                  <td colspan="100%">
                    <h6 align="center">No User Data Found</h6>
                  </td>
                </tr>
              </div>
              <div class="row col-sm-5 offset-sm-7">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                      <pagination
                        :data="pagination"
                        :limit="limit"
                        @pagination-change-page="getUserReports"
                      ></pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- profile Info End -->
      </form>
    </div>
  </div>
</template>
<style>
.vue-daterange-picker {
  width: 250px !important;
}
.daterangepicker {
  width: 700px !important;
}
.card.date-picker-space {
  margin-bottom: 100px;
}
</style>
